import { useEffect } from 'react';
import { rootElementId } from '@/constants/constants';

const useOnClickOutside = (ref: React.RefObject<any>, callback: () => void) => {
  const handleClick = (e: MouseEvent) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.getElementById(rootElementId)?.addEventListener('mousedown', handleClick);

    return () => {
      document.getElementById(rootElementId)?.removeEventListener('mousedown', handleClick);
    };
  });
};

export default useOnClickOutside;
